import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import ReflectionDemo from './ReflectionDemo'
import ReflectionElement from './ReflectionElement'
import ReflectionFormBrand from './ReflectionFormBrand'
import { STYLE_FORM_SCHEMA } from './ReflectionFormStyle'
import ReflectionFormValue from './ReflectionFormValue'
import icon from './assets/reflection.svg'

export default genElementConfig(CONFIG_ELEMENTS.reflection, {
  label: t('elements.reflection.label'),
  icon,
  group: ElementGroup.view,
  styleFields: STYLE_FORM_SCHEMA,
  Element: ReflectionElement,
  Demo: [ReflectionDemo],
  FormValue: ReflectionFormValue,
  FormBrand: ReflectionFormBrand,
  EditorActions: null,
})
